module.exports = __webpack_public_path__ + "static/media/white-identify-pan-icon.d4c64e61.svg";